var _circle, _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiempoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#5CC3FD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 22,
    height: 22,
    rx: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8544 22.9317C18.3825 22.6447 18.2663 22.0522 18.5949 21.6083L19.1897 20.8044C19.5182 20.3605 20.1671 20.2332 20.639 20.5202L25.1673 23.2742C25.8751 23.7047 26.0494 24.5935 25.5566 25.2594C25.0638 25.9253 24.0905 26.1162 23.3827 25.6857L18.8544 22.9317Z",
    fill: "#5CC3FD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 3,
    height: 11,
    rx: 1.5,
    fill: "#5CC3FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiempoIcon);
export default __webpack_public_path__ + "static/media/TiempoIcon.a0263f7d134ca6eb315ef0a130c06b90.svg";
export { ForwardRef as ReactComponent };